import type { ReactNode } from 'react';

import classNames from 'classnames';

import type { BingoWidgetFeatureType } from '../../../../types';
import { BingoWideWidgetBackground } from '../BingoWideWidgetBackground/BingoWideWidgetBackground';

import styles from './BingoWideWidgetWrapper.module.scss';

interface BingoWideWidgetWrapperProps {
  feature: BingoWidgetFeatureType;
  children: ReactNode;
  onClick?: () => void;
  wrapperClassName?: string;
}

export function BingoWideWidgetWrapper(props: BingoWideWidgetWrapperProps) {
  const { feature, onClick, children, wrapperClassName } = props;
  return (
    <div className={styles.container} role="button" onClick={onClick}>
      <BingoWideWidgetBackground bgType={feature} />
      <div className={classNames(styles.wrapper, wrapperClassName)}>
        <div className={styles.contentContainer}>{children}</div>
      </div>
    </div>
  );
}
